/* eslint-disable react/jsx-pascal-case */
import { GridFooter } from "@mui/x-data-grid-pro";
import { useContext, useEffect, useState } from "react";
import CustomToolbar from "../../../../components/grid/CustomToolbar";
import GeneralContext from "../../../../context/GeneralContext/GeneralContext";
import api from "../../../../services/api";
import days_content_grid_columns from "./grid_columns/days_content_grid_columns";
import { displayMessage } from "../../../../helpers/messages";
import SL_Button from "../../../../components/buttons/Button";
import { useNavigate, useParams } from "react-router-dom";
import { SL_Divider } from "../../../../components/divider/Divider";
import { DetailContentModal } from "./DetailContentModal";
import { CreateContentModal } from "./CreateContentModal";
import { Modal, Tabs } from "antd";
import {
	CloseOutlined,
	DeleteOutlined,
	EditOutlined,
	FilterOutlined,
	PlusCircleOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import ContentFilters from "./ContentFilters ";
import { SL_Grid } from "../../../../components/grid/SL_Grid";

export function ListContent() {
	const [modal, contextHolder] = Modal.useModal();

	const [contents, setContents] = useState(null);
	const [currentQuizRow, setCurrentQuizRow] = useState(null);
	const [isModalCreateContentOpen, setIsModalCreateContentOpen] = useState(false);
	const [isModalDetailContentOpen, setIsModalDetailContentOpen] = useState(false);
	const [isFiltersVisible, setIsFiltersVisible] = useState(false);

	const { setShowLoading, mobile_mode, windowWidth, loggedUser } = useContext(GeneralContext);


	let listContent = [];

	useEffect(() => {
		loadContent();
	}, []);

	
	function handleRowChange(e) {
		setCurrentQuizRow(e?.row);
	}

	function onClickCreateContent() {
		setIsModalCreateContentOpen(true);
	}

	async function onCloseCreateContentModal(loadData = false) {
		if (loadData) {
			await reloadGridData()
		}

		setIsModalCreateContentOpen(false);
	}

	function onClickDetailContent() {
		setIsModalDetailContentOpen(true);
	}

	async function onCloseDetailContentModal() {
		setIsModalDetailContentOpen(false);
	}

	async function reloadGridData() {
		loadContent()
	}

	function onChangeFilterVisibility() {
		setIsFiltersVisible((current) => !current);
	}

	async function loadContent(values) {
		setShowLoading(true);
		try {
			let formattedValues = []
			if (values) {
				formattedValues = values
			}

			formattedValues.by_attachment_type = 3 // 3 = Conteudo
			formattedValues.id = loggedUser.id 

			listContent = await api.content.list(formattedValues); 
			setContents(listContent.data);
		} finally {
			setShowLoading(false);
		}
	}

	function onClickRemoveQuestion() {
		modal.confirm({
			centered: true,
			content: (
				<div className="text-base w-full text-fit-red-500 text-center sm:text-start">
					{displayMessage('CONFIRM_REMOVE_CONTENT')}
				</div>
			),
			cancelText: displayMessage('CANCEL'),
			okText: displayMessage('CONFIRM'),
			okButtonProps: {
				danger: true,
			},
			onOk: removeContent,
			icon: mobile_mode ? null : <WarningOutlined style={{ color: "red" }} />,
			cancelButtonProps: {
				style: { color: "gray !important" },
			},
		});
	}

	async function removeContent() {
		try {
			setShowLoading(true);

			await api.content.delete(currentQuizRow.id);

			await loadContent();
		} finally {
			setShowLoading(false);
		}
	}

	const windowBreakpoint = windowWidth < 800 //px


	return (
		<>
			{contextHolder}
			{isModalCreateContentOpen && (
				<CreateContentModal
					onCloseModal={onCloseCreateContentModal}
					loadContent={loadContent}
				/>
			)}
			{isModalDetailContentOpen && (
				<DetailContentModal
					onCloseModal={onCloseDetailContentModal}
					reloadGridData={reloadGridData}
					idContent={currentQuizRow.id}
				/>
			)}

			<div className="flex flex-col flex-1 h-full">
				<div className='flex flex-1 flex-col'>
					<div className="flex flex-col flex-1 h-full">
						<div className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}>
						<div className='self-center text-white font-semibold text-base'>{displayMessage('CONTENT_LIST')}</div>

							<div className={`flex-1 flex flex-wrap gap-2 justify-end`}>
								<div className={`flex-1 flex ${mobile_mode ? 'flex-col' : 'flex-wrap'} gap-2 justify-end`}>
									<SL_Button
										type="default"
										disabled={!currentQuizRow}
										className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
										onClick={onClickDetailContent}
										icon={<EditOutlined className='text-base flex items-center' />}
									>
										<span className="flex-1">{displayMessage('VIEW_CONTENT')}</span>
									</SL_Button>

									<SL_Button
										type="default"
										className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
										onClick={onClickCreateContent}
										icon={<PlusCircleOutlined className='text-base flex items-center' />}
									>
										<span className="flex-1">
											{displayMessage("ADD_CONTENT")}
										</span>
									</SL_Button>
								</div>
								<SL_Button
									disabled={!currentQuizRow}
									className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
									danger={true}
									onClick={onClickRemoveQuestion}
									icon={<DeleteOutlined className=' text-base flex items-center' />}
								>
									<span className=" flex-1">
										{displayMessage("REMOVE_CONTENT")}
									</span>
								</SL_Button>

								<SL_Button
									style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
									type="default"
									shape="circle"
									onClick={onChangeFilterVisibility}
									icon={
										!isFiltersVisible ? (
											<FilterOutlined className="text-base flex items-center" />
										) : (
											<CloseOutlined className="text-fit-red-800 text-base flex items-center" />
										)
									}
								></SL_Button>
							</div>
						</div>

						{isFiltersVisible && (<ContentFilters onSearch={loadContent} filterHeight={'20vh'} />)}

						<div className={`w-full flex-1 min-h-[400px] smb:min-h-0`} >
							<SL_Grid
								rows={contents ?? []}
								columns={days_content_grid_columns}
								components={{
									Toolbar: () => <CustomToolbar />,
									Footer: () => <GridFooter />,
								}}
								onRowClick={handleRowChange}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
